<template>
  <v-flex xs12 sm12>
    <v-card flat>
      <v-toolbar dense card flat>
        <v-toolbar-title class="body-2 beez-bold ">
          Automation Services
        </v-toolbar-title>
        <v-spacer />
        <v-tooltip bottom>
          <v-btn slot="activator" icon flat @click.stop="refresh">
            <v-icon>
              cached
            </v-icon>
          </v-btn>
          <span>Refresh</span>
        </v-tooltip>
      </v-toolbar>
      <v-flex class="scroll-y">
        <v-layout row wrap class="py-1">
          <v-flex xs12 class="py-2">
            <v-toolbar flat style="border-radius: 5px">
              <v-list-tile-avatar>
                <v-icon>search</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-sub-title>
                  <v-text-field
                    hide-details
                    single-line
                    label="Search Automation Services"
                    v-model="searchTerm"
                    xs5
                    @change="searchServices()"
                    color="secondary"
                  >
                  </v-text-field>
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-tooltip bottom>
                <v-btn
                  slot="activator"
                  icon
                  @click="
                    searchTerm = ''
                    refresh()
                  "
                >
                  <v-icon>clear</v-icon>
                </v-btn>
                <span>Clear</span>
              </v-tooltip>
            </v-toolbar>
          </v-flex>
          <v-flex xs12>
            <v-progress-linear
              color="accent"
              indeterminate
              v-if="loader"
            ></v-progress-linear>
            <v-layout row wrap>
              <v-flex
                shrink
                grow
                :xs12="selectedServiceHexId === item.hexId"
                :sm12="selectedServiceHexId !== item.hexId"
                :md6="selectedServiceHexId !== item.hexId"
                :lg4="selectedServiceHexId !== item.hexId"
                :xl3="selectedServiceHexId !== item.hexId"
                class="pa-1"
                :key="key + 'flex0'"
                v-for="(item, key) in beezItems"
                v-show="
                  selectedServiceHexId === null ||
                    selectedServiceHexId === item.hexId
                "
              >
                <automation-service-card
                  :key="'ar_card_' + key"
                  :item="item"
                  :selectedServiceHexId="selectedServiceHexId"
                  :loading="loader"
                  @selected-service="setSelectedServiceHexId"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex class="mt-2" style="border-radius: 5px">
            <div class="text-xs-center">
              <v-pagination
                v-if="!selectedServiceHexId"
                v-model="page"
                @input="refresh"
                :length="totalPages"
                :total-visible="5"
              ></v-pagination>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-card>
  </v-flex>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import u from '@/utils'
import moment from 'moment'
import AutomationServiceCard from './AutomationServiceCard'
import axios from 'axios'

export default {
  name: 'SelfService',
  components: {
    AutomationServiceCard
  },
  data() {
    return {
      page: 1,
      totalPages: 1,
      size: 12,
      selfServices: [],
      selectedServiceHexId: null,
      loader: false,
      searchTerm: ''
    }
  },
  mounted() {
    this.getSelectedFromRoute()
    this.refresh()
  },
  methods: {
    searchServices() {
      this.page = 1
      this.refresh()
    },
    getSelectedFromRoute() {
      if (
        this.$router.currentRoute.name === 'service' ||
        this.$router.currentRoute.name === 'service-ar-history'
      ) {
        this.selectedServiceHexId = this.$route.params.hexId
      } else {
        this.selectedServiceHexId = null
      }
    },
    getUrlParams() {
      let urlParams = ''
      urlParams += `page=${this.page}&`
      urlParams += `size=${this.size}&`

      if (this.searchTerm) {
        urlParams += `search=${this.searchTerm}&`
      }
      urlParams += `active=true`
      return urlParams
    },
    async getSelfServices() {
      this.loader = true
      const urlParams = this.getUrlParams()
      axios
        .get(`/api/v1/selfServices?${urlParams}`)
        .then(response => {
          if (response.data._embedded) {
            let services = response.data._embedded.selfServices
            this.selfServices = services.map(service => {
              return u.processResp(service)
            })
            this.totalPages = response.data.page.totalPages
            this.page = response.data.page.number
            this.loader = false
          } else {
            this.selfServices = []
            this.totalPages = 1
            this.page = 1
            this.loader = false
          }
        })
        .catch(e => {
          console.log(e)
          this.$store.dispatch('directNotification', {
            type: 'error',
            message: 'Unable to fetch Self services',
            description: e.response
              ? e.response.data.message
              : 'Error unknown! Kindly retry',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        })
    },
    async refresh() {
      this.loader = true
      try {
        await this.getSelfServices()
      } catch (e) {
        this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Self services',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.loader = false
    },
    setSelectedServiceHexId(hexId) {
      this.selectedServiceHexId = hexId
    }
  },
  computed: {
    ...mapState({
      selfServiceMetrics: state => state.selfServices.selfServiceMetrics
    }),
    ...mapGetters({
      can: 'can'
    }),
    gradient() {
      return [this.$vuetify.theme.secondary, this.$vuetify.theme.accent]
    },
    beezItems() {
      let items = []

      if (this.selfServices) {
        items = u.clone(this.selfServices)
      }
      items = items.sort(
        (prev, current) =>
          new Date(current.createdAt).getTime() -
          new Date(prev.createdAt).getTime()
      )
      items = items.filter(obj => obj.active === true)
      return items
    }
  }
}
</script>
